import React from 'react'
import { Modal } from 'components/Modal'
import { DatePickerWithError } from 'components/FormInputs/DatePicker'
import {
  InputWithValidationError,
  SimpleCustomSelect
} from 'components/FormInputs'
import { writeOffMotives, orderHardwareStatus } from '../../helpers/constants'
import { FiscalData, WriteOffInvoiceMotives } from 'models/orderItem'
import { OrderHardwareStatus } from 'models'

interface HardwareDynamicModalProps {
  isOpen: boolean
  modalType: 'cancel_fiscal_data' | 'update_item_status' | null
  onClose: () => void
  fiscalData: Partial<FiscalData>
  setFiscalData: (data: Partial<FiscalData>) => void
  itemToBeUpdatedAt: Date
  setItemToBeUpdatedAt: (date: Date) => void
  currentOrderHardwareStatus: OrderHardwareStatus
  setCurrentOrderItemStatus: (status: OrderHardwareStatus) => void
  orderActivatedAt: Date
  onSave: () => void
}

export function HardwareDynamicModal({
  isOpen,
  modalType,
  onClose,
  fiscalData,
  setFiscalData,
  itemToBeUpdatedAt,
  setItemToBeUpdatedAt,
  currentOrderHardwareStatus,
  setCurrentOrderItemStatus,
  orderActivatedAt,
  onSave
}: HardwareDynamicModalProps) {
  const isCancelModal = modalType === 'cancel_fiscal_data'
  const isUpdateStatusModal = modalType === 'update_item_status'

  const isFormValid =
    fiscalData.write_off_invoice && fiscalData.write_off_invoice.trim() !== ''

  return (
    <Modal
      open={isOpen}
      title={isCancelModal ? 'Cancelamento de pedido' : 'Mudança de estado'}
      onClose={onClose}
    >
      <div className="grid grid-cols-12 gap-4 mt-4">
        {/* Motivo só aparece no cancelamento */}
        {isCancelModal && (
          <div className="col-span-6">
            <div className="mt-1">
              <SimpleCustomSelect
                label="Motivo"
                options={writeOffMotives.cancel}
                value={
                  fiscalData.write_off_invoice_motive ??
                  writeOffMotives.cancel[0].value
                }
                onChange={(value) =>
                  setFiscalData({
                    ...fiscalData,
                    write_off_invoice_motive: value as WriteOffInvoiceMotives
                  })
                }
              />
            </div>
          </div>
        )}

        {/* Novo estado só aparece na mudança de estado */}
        {isUpdateStatusModal && (
          <div className="col-span-6">
            <div className="mt-1">
              <SimpleCustomSelect
                label="Novo estado"
                options={orderHardwareStatus}
                value={currentOrderHardwareStatus}
                onChange={(value) =>
                  setCurrentOrderItemStatus(value as OrderHardwareStatus)
                }
                error={
                  !currentOrderHardwareStatus ? 'Campo obrigatório' : undefined
                }
              />
            </div>
          </div>
        )}

        <div className="col-span-6">
          <div className="mt-1 relative">
            <DatePickerWithError
              label="Data de atualização"
              name="item_to_be_updated_at"
              minDate={new Date(orderActivatedAt)}
              maxDate={new Date()}
              date={itemToBeUpdatedAt}
              onChange={(value) => setItemToBeUpdatedAt(value as Date)}
            />
          </div>
        </div>

        <div className="col-span-6">
          <div className="mt-1">
            <InputWithValidationError
              label={
                isCancelModal ? 'Nota fiscal de cancelamento' : 'Nota fiscal'
              }
              type="text"
              name="write_off_invoice"
              id="write_off_invoice"
              value={fiscalData.write_off_invoice ?? ''}
              onChange={(value) =>
                setFiscalData({
                  ...fiscalData,
                  write_off_invoice: value
                })
              }
              error={!isFormValid ? 'Campo obrigatório' : undefined}
            />
          </div>
        </div>

        <div className="col-span-6">
          <div className="mt-1 relative">
            <DatePickerWithError
              label="Data de emissão"
              name="write_off_date"
              date={
                fiscalData.write_off_date
                  ? fiscalData.write_off_date
                  : new Date()
              }
              onChange={(value) =>
                setFiscalData({
                  ...fiscalData,
                  write_off_date: value ? new Date(value) : undefined
                })
              }
            />
          </div>
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
          onClick={onClose}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
          onClick={onSave}
          disabled={!isFormValid}
        >
          Salvar
        </button>
      </div>
    </Modal>
  )
}
